import React, { useEffect, useState } from "react";
import "./App.css";
import MaxWidthWrapper from "./components/layout/header/max-width-wrapper/MaxWidthWrapper";
import Header from "./components/layout/header/Header";
import BrowserRoutes from "./router/BrowserRoutes";
import { BrowserRouter } from "react-router-dom";
import HeaderContext from "./components/layout/header/header-context/HeaderContext";
import SideBar from "./components/layout/sidebar/Sidebar";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { GlobalContextProvider } from "./components/layout/global-context/globalContext";

function App() {
  const { instance, accounts } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const [headerTitle, setHeaderTitle] = useState<string>("");
  const [currentUserId, setCurrentUserId] = useState<string>("");
  const [roles, setRoles] = useState<string[]>([]);

  useEffect(() => {
    if (accounts && accounts.length > 0) {
      setCurrentUserId(activeAccount!.username);
      setRoles(activeAccount?.idTokenClaims?.roles || []);
    }
    // eslint-disable-next-line
  }, [accounts, instance]);

  useEffect(() => {
    const appEnv = process.env.REACT_APP_APP_ENV;
    const buildInfo = process.env.REACT_APP_BUILD_INFO;
    console.log("app_env: %o", appEnv);
    console.log("buildNumber: %o", buildInfo);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Redirect}
          // errorComponent={ErrorComponent}
          // loadingComponent={Loading}
        >
          {activeAccount ? (
            <GlobalContextProvider>
              <div className="flex h-screen w-full bg-bdo-bg-03-charcoal-paler font-proximanova">
                <SideBar />
                <MaxWidthWrapper className="flex-col viewsContainer">
                  <HeaderContext.Provider
                    value={{
                      setHeaderTitle,
                      headerTitle,
                      currentUserId,
                      roles,
                    }}
                  >
                    <Header />
                    <BrowserRoutes />
                  </HeaderContext.Provider>
                </MaxWidthWrapper>
              </div>
            </GlobalContextProvider>
          ) : null}
        </MsalAuthenticationTemplate>
      </BrowserRouter>
    </div>
  );
}
export default App;
